import { MainSidebar } from "@/components/sidebars/MainSidebar";
import { useState } from "react";
import { GenerationPresetPanel } from "./GenerationPresetPanel";
import { SectionTemplatePanel } from "./SectionTemplatePanel";

const TABS = [
  { id: "presets", label: "Generation presets" },
  { id: "templates", label: "Section templates" },
] as const;

type Tab = (typeof TABS)[number]["id"];

/**
 * Where generation presets and the section templates they follow are kept, with room the dropdowns
 * inside the generator do not have: a preset's scope and section order, and a preview of every
 * template's reference slide.
 */
export function PresetsPage() {
  const [tab, setTab] = useState<Tab>("presets");

  return (
    <div className="flex h-screen">
      <MainSidebar />
      <main className="flex min-w-0 flex-1 flex-col gap-4 overflow-hidden p-6">
        <div>
          <h1 className="h3">Presets</h1>
          <p className="body-sm text-gray-500 dark:text-gray-400">
            What slide generation starts from, kept in one place.
          </p>
        </div>

        <div
          role="tablist"
          aria-label="Preset kinds"
          className="flex gap-1 border-b border-gray-200 dark:border-gray-800"
        >
          {TABS.map((one) => (
            <button
              key={one.id}
              type="button"
              role="tab"
              aria-selected={tab === one.id}
              onClick={() => setTab(one.id)}
              className={`-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors ${
                tab === one.id
                  ? "border-primary-500 text-primary-600 dark:text-primary-300"
                  : "border-transparent text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100"
              }`}
            >
              {one.label}
            </button>
          ))}
        </div>

        {tab === "presets" ? <GenerationPresetPanel /> : <SectionTemplatePanel />}
      </main>
    </div>
  );
}
